import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useGetShopBasicDataQuery } from "../../../../store/queries/Master";
import { updateConfig } from "../../../../store/slices/Master/Shop/shopSlice";

const useFilter = () => {
  const queryState = useSelector((state) => state.shop);
  const dispatch = useDispatch();
  const { data: basicData = {} } = useGetShopBasicDataQuery();

  const formik = useFormik({
    initialValues: {
      customer_type: queryState?.filter?.customer_type ?? "",
      add_as: queryState?.filter?.add_as ?? "",
    },
    onSubmit: (values) => {
      dispatch(
        updateConfig((state) => {
          state.showFilter = false;
          state.currentPage = 1;
          state.filter.customer_type = values?.customer_type;
          state.filter.add_as = values?.add_as;
        }),
      );
    },
  });

  const handleReset = () => {
    formik?.handleReset();
    dispatch(
      updateConfig((state) => {
        state.showFilter = false;
        state.currentPage = 1;
        state.filter.customer_type = "";
        state.filter.add_as = "";
      }),
    );
  };

  return {
    formik,
    basicData,
    handleReset,
  };
};

export default useFilter;
